/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coming_Soon_Document_ManagemeInputs */

const en_coming_soon_document_manageme = /** @type {(inputs: Coming_Soon_Document_ManagemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming Soon: Document Management`)
};

const es_coming_soon_document_manageme = /** @type {(inputs: Coming_Soon_Document_ManagemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximamente: Gestión de documentos`)
};

const fr_coming_soon_document_manageme = /** @type {(inputs: Coming_Soon_Document_ManagemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bientôt : Gestion des documents`)
};

const de_coming_soon_document_manageme = /** @type {(inputs: Coming_Soon_Document_ManagemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demnächst: Dokumentenverwaltung`)
};

const ja_coming_soon_document_manageme = /** @type {(inputs: Coming_Soon_Document_ManagemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近日公開: ドキュメント管理`)
};

const zh_coming_soon_document_manageme = /** @type {(inputs: Coming_Soon_Document_ManagemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即将推出：文档管理`)
};

const ar_coming_soon_document_manageme = /** @type {(inputs: Coming_Soon_Document_ManagemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قريباً: إدارة المستندات`)
};

const id_coming_soon_document_manageme = /** @type {(inputs: Coming_Soon_Document_ManagemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segera Hadir: Manajemen Dokumen`)
};

const it_coming_soon_document_manageme = /** @type {(inputs: Coming_Soon_Document_ManagemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Arrivo: Gestione dei Documenti`)
};

const ru_coming_soon_document_manageme = /** @type {(inputs: Coming_Soon_Document_ManagemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скоро появится: Управление документами`)
};

const pt_coming_soon_document_manageme = /** @type {(inputs: Coming_Soon_Document_ManagemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em Breve: Gestão de Documentos`)
};

const ko_coming_soon_document_manageme = /** @type {(inputs: Coming_Soon_Document_ManagemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`출시 예정: 문서 관리 기능`)
};

/**
* | output |
* | --- |
* | "Coming Soon: Document Management" |
*
* @param {Coming_Soon_Document_ManagemeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const coming_soon_document_manageme = /** @type {((inputs?: Coming_Soon_Document_ManagemeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coming_Soon_Document_ManagemeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coming_soon_document_manageme(inputs)
	if (locale === "es") return es_coming_soon_document_manageme(inputs)
	if (locale === "fr") return fr_coming_soon_document_manageme(inputs)
	if (locale === "de") return de_coming_soon_document_manageme(inputs)
	if (locale === "ja") return ja_coming_soon_document_manageme(inputs)
	if (locale === "zh") return zh_coming_soon_document_manageme(inputs)
	if (locale === "ar") return ar_coming_soon_document_manageme(inputs)
	if (locale === "id") return id_coming_soon_document_manageme(inputs)
	if (locale === "it") return it_coming_soon_document_manageme(inputs)
	if (locale === "ru") return ru_coming_soon_document_manageme(inputs)
	if (locale === "pt") return pt_coming_soon_document_manageme(inputs)
	return ko_coming_soon_document_manageme(inputs)
});